export const min = (length) => (value) => {
	if (value && value.length < length) {
		return `Must be longer than ${length} character`;
	}
};
